import { render, staticRenderFns } from "./DdYearMonthBox.vue?vue&type=template&id=12bd94dc&scoped=true&"
import script from "./DdYearMonthBox.vue?vue&type=script&lang=js&"
export * from "./DdYearMonthBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd94dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
